import { Grow } from "@mui/material";
import { FC } from "react";
import { Award } from "../../types";

import "./style.css";

interface IAwardReveal {
  award: Award;
  active: boolean;
  onClose: () => void;
}

export const AwardReveal: FC<IAwardReveal> = ({ award, active, onClose }) => (
  <Grow in={active}>
    <div className="awardRevealOverlay" onClick={onClose}>
      <div className="awardRevealCard" onClick={(e) => e.stopPropagation()}>
        <p className="awardRevealTitle">Felicidades!</p>
        {award.imageUrl && (
          <img
            className="awardRevealImage"
            src={award.imageUrl}
            alt={award.label}
          />
        )}
        <p className="awardRevealLabel">{award.label}</p>
        <p className="awardRevealDescription">{award.description}</p>
        <span className="awardRevealClose" onClick={onClose}>
          Toca para cerrar
        </span>
      </div>
    </div>
  </Grow>
);
